import axios from "axios";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useDataContext } from "../../../utils/DataContext";
import "../../../styles/org-buttons.css";
import { buttonText } from "../../../utils/buttonText";

function DatasetPage(props) {
  const { item, loadDatasetList } = props;
  const { datasetNames } = useDataContext();
  const [datasetName, setDatasetName] = useState(null);
  const [cloneLoading, setCloneLoading] = useState(false);

  const cloneDataset = async () => {
    setCloneLoading(true);
    axios
      .put(
        `/datasets/samples/clone?dataset_name=${item.name}&target_dataset_name=${datasetName}`
      )
      .then((response) => {
        loadDatasetList();
        window.alert(`Clone dataset success`);
        setCloneLoading(false);
      })
      .catch((error) => {
        let errorMsg = error.response.data;
        window.alert(errorMsg);
        setCloneLoading(false);
      });
  };

  return (
    <div className="acquisition-upload-page">
      <select
        value={datasetName}
        onChange={(e) => {
          setDatasetName(e.target.value);
        }}
      >
        <option value="">--Choose a dataset to clone--</option>
        {datasetNames &&
          datasetNames.map((dataset) => (
            <option key={dataset} value={dataset}>
              {dataset}
            </option>
          ))}
      </select>
      <Modal.Footer className="org-modal-footer">
        <button
          type="button"
          className="org-btn org-btn-primary"
          onClick={cloneDataset}
          disabled={cloneLoading}
        >
          {buttonText(cloneLoading ? "Cloning..." : "Clone")}
        </button>
      </Modal.Footer>
    </div>
  );
}

export default DatasetPage;
